export default "__VITE_ASSET__DCmQnVlZ__"